import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2 d-print-none" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-2 col-6" }
const _hoisted_5 = { class: "col-md-2 col-6" }
const _hoisted_6 = { class: "col-md-2 col-6" }
const _hoisted_7 = { class: "col-md-2 col-6" }
const _hoisted_8 = { class: "col-md-2 col-6" }
const _hoisted_9 = { class: "col-md-2 col-6" }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  class: "dropdown-menu p-2",
  style: {"min-width":"200px"}
}
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = ["id", "onUpdate:modelValue"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_17 = { class: "p-4 text-danger fw-14" }
const _hoisted_18 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_19 = { class: "mb-1 text-muted f12px" }
const _hoisted_20 = { style: {"overflow-x":"auto"} }
const _hoisted_21 = {
  class: "tabela table-sm table-bordered f12px",
  id: "tabela-relatorio"
}
const _hoisted_22 = { class: "table-relatorio" }
const _hoisted_23 = { class: "text-center colId" }
const _hoisted_24 = {
  key: 0,
  class: "text-start colNome"
}
const _hoisted_25 = {
  key: 1,
  class: "text-center colCpf"
}
const _hoisted_26 = {
  key: 2,
  class: "text-start colNomeConj"
}
const _hoisted_27 = {
  key: 3,
  class: "text-center colCpf"
}
const _hoisted_28 = {
  key: 4,
  class: "text-start"
}
const _hoisted_29 = {
  key: 5,
  class: "text-start colNomeDepend"
}
const _hoisted_30 = {
  key: 6,
  class: "text-center colData"
}
const _hoisted_31 = {
  key: 7,
  class: "text-center colCpf"
}
const _hoisted_32 = {
  key: 8,
  class: "text-center colTelefone"
}
const _hoisted_33 = {
  key: 3,
  class: "text-center p-4 text-muted"
}
const _hoisted_34 = {
  key: 4,
  class: "text-center p-4 text-muted"
}

import { reactive, computed } from "vue";

import * as relatoriosService from "@/services/relatoriosService";
import { fdata } from "@/utils/funcoes";
import { useOrdenacao } from "@/composables/useOrdenacao";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import ReportView from "@/components/ReportView/Index.vue";
import ReportCabecalho from "@/components/ReportView/Cabecalho.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesDependentes',
  setup(__props) {


const colunasOpcionais = [
  { chave: "nome", label: "Nome" },
  { chave: "cpf", label: "CPF" },
  { chave: "nomeConjuge", label: "Nome Cônjuge" },
  { chave: "cpfConjuge", label: "CPF Cônjuge" },
  { chave: "parentesco", label: "Parentesco" },
  { chave: "nomeDependente", label: "Nome Dependente" },
  { chave: "nascimentoDependente", label: "Nascimento" },
  { chave: "cpfDependente", label: "CPF Depend" },
  { chave: "telefoneDependente", label: "Telefone" },
];

const controle = reactive({
  filtros: {
    vendedorId: null,
    planoId: null,
    ativo: true,
    dataCadastroInicial: null,
    dataCadastroFinal: null,
  } as relatoriosService.FiltroClientesDependentes,

  itens: [] as relatoriosService.RelClienteDependenteDTO[],
  totalRegistros: 0,

  colunasVisiveis: {
    nome: true,
    cpf: true,
    nomeConjuge: true,
    cpfConjuge: true,
    parentesco: true,
    nomeDependente: true,
    nascimentoDependente: true,
    cpfDependente: true,
    telefoneDependente: false,
  } as Record<string, boolean>,

  erro: "",
  status: "",
  pesquisando: false,
});

async function pesquisar() {
  controle.pesquisando = true;
  controle.erro = "";
  try {
    const r = await relatoriosService.clientesDependentes(controle.filtros);
    controle.totalRegistros = r.totalRegistros;
    controle.itens = r.dados;
  } catch (e: any) {
    controle.erro = e?.message || "Erro ao pesquisar";
  } finally {
    controle.pesquisando = false;
  }
}

const sort = useOrdenacao();

const itensOrdenados = computed(() => sort.aplicar(controle.itens, {
  id: (item: relatoriosService.RelClienteDependenteDTO) => item.clienteId,
  nascimentoDependente: (item: relatoriosService.RelClienteDependenteDTO) => item.dataNascimentoDependente || "",
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Clientes X Dependentes",
      items: [
    { label: 'Relatórios', to: '/relatorios' },
    { label: 'Clientes X Dependentes', to: '/relatorios/clientesdependentes' }]
    }),
    _createVNode(Notificacao, {
      erro: controle.erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (controle.erro = '')),
      progresso: controle.status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (controle.status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Vendedor", -1)),
                _createVNode(DropdownVendedores, {
                  modelValue: controle.filtros.vendedorId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.filtros.vendedorId) = $event)),
                  id: "vendedorId"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "Plano", -1)),
                _createVNode(DropdownPlanos, {
                  modelValue: controle.filtros.planoId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((controle.filtros.planoId) = $event)),
                  id: "planoId"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Dt Cad Ini", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controle.filtros.dataCadastroInicial) = $event)),
                  type: "date",
                  class: "form-control form-control-sm",
                  id: "dataCadastroInicial"
                }, null, 512), [
                  [_vModelText, controle.filtros.dataCadastroInicial]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "Dt Cad Fin", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((controle.filtros.dataCadastroFinal) = $event)),
                  type: "date",
                  class: "form-control form-control-sm",
                  id: "dataCadastroFinal"
                }, null, 512), [
                  [_vModelText, controle.filtros.dataCadastroFinal]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Ativo", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((controle.filtros.ativo) = $event)),
                  class: "form-select form-select-sm",
                  id: "ativo"
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Ativos", -1),
                  _createElementVNode("option", { value: false }, "Inativos", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.ativo]
                ])
              ]),
              _createElementVNode("div", { class: "col-md-2 col-6" }, [
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm mt-4",
                  onClick: pesquisar
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
                  _createTextVNode(" Pesquisar ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[24] || (_cache[24] = _createElementVNode("a", {
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle mt-4",
                    href: "#",
                    role: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", { class: "fa fa-table-columns me-1" }),
                    _createTextVNode(" Colunas ")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colunasOpcionais, (col) => {
                      return _createElementVNode("li", {
                        key: col.chave
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: 'col_' + col.chave,
                            "onUpdate:modelValue": ($event: any) => ((controle.colunasVisiveis[col.chave]) = $event)
                          }, null, 8, _hoisted_13), [
                            [_vModelCheckbox, controle.colunasVisiveis[col.chave]]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: 'col_' + col.chave
                          }, _toDisplayString(col.label), 9, _hoisted_14)
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ReportView, {
            titulo: 'Rel Clientes X Dependentes',
            btnImprimir: true,
            orientacao: 'Paisagem'
          }, {
            default: _withCtx(() => [
              (controle.erro != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(controle.erro), 1)
                  ]))
                : _createCommentVNode("", true),
              (controle.erro == '' && controle.pesquisando)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("div", { class: "p-4" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-2x fa-spin" }),
                      _createElementVNode("div", { class: "fw-16" }, "Pesquisando...")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(ReportCabecalho, {
                      Titulo: 'Relatório de Clientes X Dependentes',
                      Filtros: `Ativo: ${controle.filtros.ativo === true ? 'Ativos' : controle.filtros.ativo === false ? 'Inativos' : 'Todos'}  |  Dt Cadastro: ${controle.filtros.dataCadastroInicial ? _unref(fdata)(controle.filtros.dataCadastroInicial) : '...'} a ${controle.filtros.dataCadastroFinal ? _unref(fdata)(controle.filtros.dataCadastroFinal) : '...'}`
                    }, null, 8, ["Filtros"]),
                    _createElementVNode("div", _hoisted_19, "Total: " + _toDisplayString(controle.itens.length) + " registro(s)", 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("table", _hoisted_21, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_22, [
                            _createElementVNode("th", {
                              class: "text-center colId col-ordenavel",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(sort).alternar('id')))
                            }, [
                              _cache[26] || (_cache[26] = _createTextVNode("Id ", -1)),
                              _createElementVNode("i", {
                                class: _normalizeClass(_unref(sort).classeIcone('id'))
                              }, null, 2)
                            ]),
                            (controle.colunasVisiveis.nome)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 0,
                                  class: "text-start colNome col-ordenavel",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(sort).alternar('nome')))
                                }, [
                                  _cache[27] || (_cache[27] = _createTextVNode("Nome ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('nome'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.cpf)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 1,
                                  class: "text-center colCpf col-ordenavel",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(sort).alternar('cpf')))
                                }, [
                                  _cache[28] || (_cache[28] = _createTextVNode("CPF ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('cpf'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.nomeConjuge)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 2,
                                  class: "text-start colNomeConj col-ordenavel",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(sort).alternar('nomeConjuge')))
                                }, [
                                  _cache[29] || (_cache[29] = _createTextVNode("Nome Cônjuge ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('nomeConjuge'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.cpfConjuge)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 3,
                                  class: "text-center colCpf col-ordenavel",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(sort).alternar('cpfConjuge')))
                                }, [
                                  _cache[30] || (_cache[30] = _createTextVNode("CPF Cônjuge ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('cpfConjuge'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.parentesco)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 4,
                                  class: "text-start colTipo col-ordenavel",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(sort).alternar('parentesco')))
                                }, [
                                  _cache[31] || (_cache[31] = _createTextVNode("Tipo ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('parentesco'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.nomeDependente)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 5,
                                  class: "text-start colNomeDepend col-ordenavel",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(sort).alternar('nomeDependente')))
                                }, [
                                  _cache[32] || (_cache[32] = _createTextVNode("Dependente ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('nomeDependente'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.nascimentoDependente)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 6,
                                  class: "text-center colData col-ordenavel",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(sort).alternar('nascimentoDependente')))
                                }, [
                                  _cache[33] || (_cache[33] = _createTextVNode("Nascto ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('nascimentoDependente'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.cpfDependente)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 7,
                                  class: "text-center colCpf col-ordenavel",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(sort).alternar('cpfDependente')))
                                }, [
                                  _cache[34] || (_cache[34] = _createTextVNode("CPF ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('cpfDependente'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.telefoneDependente)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 8,
                                  class: "text-center colTelefone col-ordenavel",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(sort).alternar('telefoneDependente')))
                                }, [
                                  _cache[35] || (_cache[35] = _createTextVNode("Telefone ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('telefoneDependente'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itensOrdenados.value, (item, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", _hoisted_23, _toDisplayString(item.clienteId), 1),
                              (controle.colunasVisiveis.nome)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(item.nome), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.cpf)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(item.cpf), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.nomeConjuge)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(item.nomeConjuge ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.cpfConjuge)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(item.cpfConjuge ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.parentesco)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(item.parentesco ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.nomeDependente)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(item.nomeDependente ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.nascimentoDependente)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(item.dataNascimentoDependente ? _unref(fdata)(item.dataNascimentoDependente) : '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.cpfDependente)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(item.cpfDependente ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.telefoneDependente)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(item.telefoneDependente ?? '-'), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros === 0 && controle.status === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[36] || (_cache[36] = [
                    _createTextVNode(" Utilize os filtros acima e clique em ", -1),
                    _createElementVNode("strong", null, "Pesquisar", -1),
                    _createTextVNode(" para gerar o relatório. ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Nenhum registro encontrado com os filtros selecionados."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})